import { createModel } from "@rematch/core";
import { apiInstance } from "shared/api/config/apiInstance";
import { RootModel } from "../rootModel";
import { ILinkSupports } from "shared/models/store/ILinkSupports";
import { IGetLink, IValidateDocuments } from "shared/models";
import { getData, putUploadDocBlob } from "shared/api/services";
import { cleanFileName } from "shared/utils/helpers/cleanFileName";
import axios from "axios";
import Swal from "sweetalert2";

export const linkSupports = createModel<RootModel>()({
  state: {
    response: [],
    openModal: false,
    loading:false,
    supports: []
  } as ILinkSupports,
  reducers: {
    getLink(state,payload){
      return {
        ...state,
        response: payload,
        loading: false,
      };
    },
    addSupports(state,payload){
      return {
        ...state,
        supports: payload,
      };
    },
    toogleModal(state, payload) {
      return {
        ...state,
        openModal: payload,
      };
    },
    isLoading(state, payload){
      return {
        ...state,
        loading: payload,
      };
    },
    cleanState(state) {
      return {
        ...state,
        response: [],
        openModal: false,
        loading: false,
      };
    },
    filterLinkState(state, payload){
      return {
        ...state,
        response: state.response?.filter(link => link.id !== payload),
      };
    },
    cleanSupports(state){
      return{
        ...state,
        supports: []
      }
    }
  },
  effects: (dispatch) => ({
    async getLinkAsync(params:IGetLink, state) {   
         
      dispatch.linkSupports.isLoading(true);
      const response = await apiInstance.post(params.url, {
        fileNames: params.file.map((x:any)=> cleanFileName(x.name.replace(/\s+/g, ''))) ,
        supportsId: params.codes
      }).finally(()=>{
        dispatch.linkSupports.isLoading(false)
      })

      await response?.data && response.data.map((data:any) => {
        const file = params.file.find((f:any)=> cleanFileName(f.name) === data.originalName);
        return putUploadDocBlob(data.link, data.id, data.originalName, file).then(()=>{
        }).catch(()=>{
          dispatch.linkSupports.isLoading(false)
        })
      })

      dispatch.linkSupports.getLink(
        state.linkSupports.response!.concat(
          response.data.map((resp:any)=>
            {return {id: resp.id, originalName: resp.originalName}
          })
        )
      )
    },

    async getLinkGlossesAsync(params:IGetLink, state) {

      dispatch.linkSupports.isLoading(true);
      try {
        const response = await apiInstance.post(
          params.url, 
          params.file, 
        )

        dispatch.linkSupports.getLink(
          state.linkSupports.response!.concat([
            {id: response.data.id, originalName: response.data.originalName}
          ])
        )

      } catch (e: any) {
        Swal.fire({
          title: "Carga fallida",
          text: `${
            e?.response.status === 403 ? "Debe subir un nuevo archivo" : e.message
          }`,
          icon: "error",
          timer: 5500,
        });
        return false;
      } finally{
        dispatch.linkSupports.isLoading(false)
      }
      
    },

    async validateLinkAsync(params:IValidateDocuments, state) {
      dispatch.linkSupports.isLoading(true);

      await apiInstance.post(params.url, {
        attachmentIds: params.attachmentIds,
      }).then(()=>{
        dispatch.linkSupports.cleanState();
      }).catch((e)=>{
        dispatch.linkSupports.isLoading(false)
      });

    },
  }),
});
